<template>
  <el-dialog
    :modal-append-to-body="true"
    :append-to-body="true"
    :title="dialogTitle"
    :visible.sync="show"
    width="420px"
    :close-on-click-modal="false"
    @open="handlerOpen"
    @close="handlerCloseDialog"
  >
    <div v-loading="loading" :element-loading-text="$t('common.loading')">
      <el-checkbox-group v-model="values" class="assign-roles__list">
        <el-checkbox v-for="item in roles" :key="item.id" :label="item.id" class="assign-roles__item">{{
          item.name
        }}</el-checkbox>
      </el-checkbox-group>
      <div v-if="!loading && roles.length === 0" class="assign-roles__empty">{{ $t("common.noData") }}</div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="show = false">{{ $t("common.cancel") }}</el-button>
      <el-button type="primary" :loading="saving" @click="save">{{ $t("common.definite") }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
  // 单用户角色分配：逻辑来源于 UserRole.vue 的 editRole/saveUserRole（弹窗版，仅面向传入的单个用户）。
  // 角色勾选来源与 payload 与旧组件保持一致：AuthorityRole.loadRole 取列表，AuthorityUserRole.save 保存。
  export default {
    name: "AssignRoles",
    props: {
      dialogVisible: Boolean,
      targetUser: Object
    },
    data() {
      return {
        loading: false,
        saving: false,
        roles: [],
        values: []
      };
    },
    computed: {
      // 代理 prop，避免直接改写 prop（父级以 @close 回收状态；此处不再直接赋值 prop）
      show: {
        get() {
          return this.dialogVisible;
        },
        set(val) {
          if (!val) {
            this.$emit("close");
          }
        }
      },
      dialogTitle() {
        const name = (this.targetUser && (this.targetUser.userName || this.targetUser.nickName)) || "";
        return this.$t("userRole.assign") + (name ? " — " + name : "");
      }
    },
    methods: {
      handlerCloseDialog() {
        this.$emit("close");
      },
      handlerOpen() {
        this.values = [];
        if (this.targetUser && this.targetUser.roleList && this.targetUser.roleList.length > 0) {
          this.targetUser.roleList.forEach(item => {
            if (item) {
              this.values.push(item.id);
            }
          });
        }
        this.loadRoles();
      },
      // 与 UserRole.vue 的 getRoleList 同一接口（listByPid 与 loadRole 指向同一后端路由）
      loadRoles() {
        this.loading = true;
        this.$api
          .request(this.$url.AuthorityRole.loadRole, this.$method.get)
          .then(res => {
            if (res.code === 0) {
              this.roles = res.data;
            }
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      },
      // 与 UserRole.vue 的 saveUserRole 保持一致的保存条件与 payload 形状
      save() {
        if (!this.targetUser || !this.targetUser.id) {
          return;
        }
        if (this.values.length <= 0) {
          this.$message.warning(this.$t("userRole.pRole"));
          return;
        }
        this.saving = true;
        let obj = { id: this.targetUser.id, roleIds: this.values };
        this.$api
          .request(this.$url.AuthorityUserRole.save, this.$method.post, obj)
          .then(res => {
            if (res.code === 0) {
              this.$message.success(this.$t("userRole.success"));
              this.$emit("saved");
              this.$emit("close");
            } else {
              this.$message.error(res.msg);
            }
            this.saving = false;
          })
          .catch(() => {
            this.saving = false;
          });
      }
    }
  };
</script>

<style lang="scss" scoped>
  .assign-roles__list {
    max-height: 320px;
    overflow-y: auto;
    display: block;
  }
  .assign-roles__item {
    display: block;
    margin: 8px 0;
  }
  .assign-roles__empty {
    color: var(--vtm-ink-2);
    padding: 10px 0;
  }
</style>
